export default function getProtocol() {
  'use strict'
  return window.location.href.split(':')[0]
}




// WEBPACK FOOTER //
// ./F:/Development/geoviewer2/src/util/getProtocol.js